/* Holasticker · barra fija de compra en el movil (fichas de textil).

   En el movil el boton de compra queda a varias pantallas de la foto. La
   barra ensena el precio de la opcion elegida y lleva a la zona de compra;
   al lado, presupuesto por WhatsApp para empresas que prefieren preguntar.
   Se esconde cuando la zona de compra ya esta a la vista o el editor esta
   abierto. Todo va en try/catch: si algo falla, la ficha sigue igual. */
(function () {
  'use strict';
  if (window.__hsBarra) return;
  window.__hsBarra = true;

  try {
    var WA = 'https://wa.me/34611328277?text=';

    var css = document.createElement('style');
    css.textContent =
      '.hs-barra{display:none}' +
      '@media (max-width:749px){' +
      '.hs-barra{position:fixed;left:0;right:0;bottom:0;z-index:8999;display:flex;align-items:center;gap:8px;' +
      'padding:10px 12px calc(10px + env(safe-area-inset-bottom));background:#fff;border-top:1px solid rgba(0,0,0,.08);' +
      'box-shadow:0 -6px 18px rgba(0,0,0,.08);transform:translateY(110%);transition:transform .25s ease}' +
      '.hs-barra.is-visible{transform:none}' +
      '.hs-barra__precio{display:flex;flex-direction:column;line-height:1.15;min-width:0;flex:1}' +
      '.hs-barra__precio small{font-size:11px;opacity:.65}' +
      '.hs-barra__precio strong{font-size:17px}' +
      '.hs-barra__ir{flex:0 0 auto;border:0;border-radius:999px;background:#ff4d94;color:#fff;font-weight:700;font-size:14px;padding:12px 16px}' +
      '.hs-barra__wa{flex:0 0 auto;display:flex;align-items:center;justify-content:center;width:44px;height:44px;border-radius:50%;background:#25d366;color:#fff}' +
      'body.hs-barra-on .hs-wa{bottom:84px!important}' +
      '}';
    document.head.appendChild(css);

    var titulo = (document.querySelector('h1') || {}).textContent || 'ropa personalizada';
    titulo = titulo.trim();

    var barra = document.createElement('div');
    barra.className = 'hs-barra';
    barra.setAttribute('role', 'region');
    barra.setAttribute('aria-label', 'Comprar');
    barra.innerHTML =
      '<div class="hs-barra__precio"><small data-hs-barra-op></small><strong data-hs-barra-precio></strong></div>' +
      '<a class="hs-barra__wa" target="_blank" rel="noopener" aria-label="Pedir presupuesto por WhatsApp" data-hs-barra-wa>' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.3-.5.1-1 .2-3.4-.7-2.8-1.1-4.6-4-4.8-4.2-.1-.2-1.1-1.5-1.1-2.9s.7-2.1 1-2.4c.3-.3.6-.3.8-.3h.6c.2 0 .4 0 .6.5l.9 2.1c.1.2.1.4 0 .6l-.4.6-.4.4c-.1.2-.3.3-.1.6.2.3.8 1.3 1.8 2.1 1.2 1.1 2.2 1.4 2.5 1.6.3.1.5.1.6-.1l.9-1c.2-.3.4-.2.6-.1l2 .9c.3.1.5.2.5.3.1.2.1.6-.1 1.2z"/></svg></a>' +
      '<button type="button" class="hs-barra__ir" data-hs-barra-ir>Personalizar y pedir</button>';
    document.body.appendChild(barra);

    function zonaCompra() {
      return document.querySelector('.product-form-buttons') || document.querySelector('form[action*="/cart/add"]');
    }

    function opcionTexto() {
      var p = document.querySelector('[data-hs-opts] [data-hs-group="pack"]:checked, [data-hs-opts] .hs-card--pack input:checked');
      var c = document.querySelector('[data-hs-opts] [data-hs-group="color"]:checked');
      return [p && p.dataset.hsLabel, c && c.dataset.hsLabel].filter(Boolean).join(' · ');
    }

    function pintar() {
      var pr = document.querySelector('.product-details product-price .price');
      var t = pr ? pr.textContent.trim() : '';
      var a = barra.querySelector('[data-hs-barra-precio]');
      var o = barra.querySelector('[data-hs-barra-op]');
      if (a.textContent !== t) a.textContent = t;
      var op = opcionTexto();
      if (o.textContent !== op) o.textContent = op;
      var msg = 'Hola, quiero presupuesto de ' + titulo + (op ? ' (' + op + ')' : '') + '.';
      barra.querySelector('[data-hs-barra-wa]').href = WA + encodeURIComponent(msg);
    }

    var zonaVista = false, arriba = true;
    function decidir() {
      var editor = document.body.classList.contains('hs-ed-abierto');
      var ver = !zonaVista && !arriba && !editor;
      barra.classList.toggle('is-visible', ver);
      document.body.classList.toggle('hs-barra-on', ver);
      if (ver) pintar();
    }

    barra.querySelector('[data-hs-barra-ir]').addEventListener('click', function () {
      var z = document.querySelector('[data-hs-opts]') || zonaCompra();
      /* Si ya ha elegido opciones (bajo la zona de opciones), a la compra. */
      var compra = zonaCompra();
      if (compra && z && window.scrollY > z.getBoundingClientRect().top + window.scrollY - 40) z = compra;
      if (z && z.scrollIntoView) z.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });

    var io = window.IntersectionObserver ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { zonaVista = e.isIntersecting; });
      decidir();
    }, { rootMargin: '0px 0px -60px 0px' }) : null;

    function vigilar() {
      var z = zonaCompra();
      if (z && io) io.observe(z);
      return !!z;
    }
    if (!vigilar()) {
      var n = 0, t = setInterval(function () { if (vigilar() || ++n > 40) clearInterval(t); }, 250);
    }

    window.addEventListener('scroll', function () {
      var a = window.scrollY < 300;
      if (a !== arriba) { arriba = a; decidir(); }
    }, { passive: true });

    document.addEventListener('change', function () { setTimeout(pintar, 50); });
    document.addEventListener('hs:cambio', function () { setTimeout(pintar, 50); });
    new MutationObserver(decidir).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  } catch (e) {
    if (window.console) console.warn('[holasticker] barra:', e);
  }
})();
